import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: 'Staking',

  staked: '{symbol} Staked',
  activateCooldown: 'Activate Cooldown',
  coolingDown: 'Cooling down',
  howToUnstake: 'How to unstake',
  unstake: 'Unstake now',
  timeLeftToUnstake: 'Time left to unstake',
  days: 'Days',
  seconds: 'Seconds',

  yourIncentives: 'Your incentives',
  incentivesToClaim: 'Claimable SSAP',
  incentivesPerMonth: 'SSAP per month',
  stakingAPY: 'Staking APR',
  currentMaxSlashing: 'Current max. slashing',
  cooldownPeriod: 'Cooldown period',
  claim: 'Claim',

  noWalletConnect: 'Please connect a wallet',
  noWalletConnectDescription: 'We couldn’t detect a wallet. Connect a wallet to stake.',
});
